import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { expenses, expensesType, expensesType_response } from "../../../services/api/api";


// Add receipt voucher state
export interface addExpenseType {
    fields: expensesType,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddExpenseTypeState: addExpenseType = {
   fields:{
    code:'',
    name:''
   },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add receipt voucher slice
export const addExpenseTypeSlice = createSlice({
    name: 'add_expenses_type',
    initialState: initialAddExpenseTypeState,
    reducers: {
        init: state => initialAddExpenseTypeState,
        set: ( state, {payload}: PayloadAction<expensesType> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setAll: ( state, {payload}: PayloadAction<expensesType> ) => {
            state.fields = payload
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})